import { render, staticRenderFns } from "./default.vue?vue&type=template&id=327314c0&scoped=true"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"
import style0 from "./default.vue?vue&type=style&index=0&id=327314c0&prod&lang=less&scoped=true"
import style1 from "./default.vue?vue&type=style&index=1&id=327314c0&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327314c0",
  null
  
)

export default component.exports